import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import blogService from "../../services/blogService";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./blog-detail.css"; // Import custom styles for the blog detail
import icon from "../../assets/img/icons/Polygon.svg";

const BlogDetail = () => {
  const { blogId } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        setLoading(true);
        const response = await blogService.getBlogById(blogId);
        setBlog(response);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [blogId]);

  // Slider settings for react-slick
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true, // Enable autoplay
    autoplaySpeed: 2000, // Set interval to 2 seconds
  };

  // if (loading) {
  //   return (
  //     <div className="flex justify-center items-center h-64">
  //       <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-blue-500"></div>
  //     </div>
  //   );
  // }

  if (error) {
    return <div className="text-center text-danger py-8">Lỗi: {error}</div>;
  }

  if (!blog) {
    return (
      <div className="text-center text-gray-500 py-8">
        Không tìm thấy bài viết
      </div>
    );
  }

  return (
    <div className="col-lg-8 col-md-12">
      <div className="card blog-details mb-4 mb-lg-0">
        <div className="card-body">
          <div className="blog-content">
            <div className="blog-image mb-5">
              {blog.imageUrls && blog.imageUrls.length > 1 ? (
                <Slider {...sliderSettings}>
                  {blog.imageUrls.map((imageUrl, index) => (
                    <div key={index} className="slider-container">
                      <img
                        src={imageUrl || "assets/img/blog/default.jpg"}
                        alt={blog.Name || "Blog Image"}
                        className="slider-image"
                      />
                    </div>
                  ))}
                </Slider>
              ) : (
                <img
                  src={blog.imageUrls[0] || "assets/img/blog/default.jpg"}
                  alt={blog.Name || "Blog Image"}
                  className="img-fluid rounded"
                  style={{ width: "100%", height: "400px", objectFit: "cover" }}
                />
              )}
            </div>
            <div className="d-flex align-items-center flex-wrap row-gap-2 mb-3">
              <Link
                to=""
                className="d-flex align-items-center fs-16 text-gray-9"
              >
                <img
                  src={blog.userImage || "assets/img/users/default-user.jpg"}
                  alt={blog.authorName || "User"}
                  className="img-fluid avatar avatar-sm rounded-circle me-2"
                />
                {blog.authorName || "User"}
              </Link>
              <div className="pe-3 border-end me-3">
                <span className="d-flex align-items-center fs-16 text-gray-9">
                  <i className="isax isax-calendar-2 me-1"></i>
                  {new Date(blog.createdDate).toLocaleDateString()}
                </span>
              </div>
              <div>
                <span className="badge badge-sm badge-primary">
                  {blog.tourName || "Travel"}
                </span>
              </div>
            </div>
            <div className="mb-3">
              <h2>
                <div
                  dangerouslySetInnerHTML={{
                    __html: blog.name || "No description available.",
                  }}
                />
              </h2>

              <div
                dangerouslySetInnerHTML={{
                  __html: blog.description || "No description available.",
                }}
              />
            </div>
            {blog.imageUrls && blog.imageUrls.length > 2 && (
              <div className="row">
                {blog.imageUrls.slice(1, 3).map((imageUrl, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="blog-image mb-3">
                      <img
                        src={imageUrl || "assets/img/blog/default.jpg"}
                        alt={blog.Name || "Blog Image"}
                        className="img-fluid rounded"
                        style={{
                          width: "100%",
                          height: "200px",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetail;
